import { render, staticRenderFns } from "./VendorContractsTableEmpty.vue?vue&type=template&id=28dffa14&scoped=true&"
var script = {}
import style0 from "./VendorContractsTableEmpty.vue?vue&type=style&index=0&id=28dffa14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dffa14",
  null
  
)

export default component.exports